
import { GridEditState } from "@/utils/grid/grid-edit-state";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			observer: null as null | ResizeObserver
		};
	},
	props: {
		cols: {
			type: Number,
			required: true
		},
		rows: Number,
		state: {
			type: Object as ()=>GridEditState,
			required: true
		},
		rowHeight: {
			type: Number,
			default: 300
		},
		ignoreHorizontalOnMobile: Boolean
	},
	computed: {
		style():any {
			if (this.$wf.isSmDown && this.ignoreHorizontalOnMobile){
				return {
					"grid-template-columns": `1fr`,
					"grid-template-rows": `repeat(${this.state.getSingleColumnRows()}, ${this.rowHeight}px)`
				};
			}
			return {
				"grid-template-columns": `repeat(${this.cols}, 1fr)`,
				"grid-template-rows": `repeat(${this.state.getRows()}, ${this.rowHeight}px)`
			};
		}
	},
	watch: {
		"state.items": {
			immediate: true,
			handler(){
				this.preventOverlap();
			}
		},
		rowHeight: {
			immediate: true,
			handler(){
				this.state.rowHeight = this.rowHeight;
			}
		},
		ignoreHorizontalOnMobile: {
			immediate: true,
			handler(){
				this.state.ignoreHorizontalOnMobile = this.ignoreHorizontalOnMobile;
			}
		},
		"$wf.isSmDown": {
			immediate: true,
			handler(val:boolean){
				if (!this.state.ignoreHorizontalOnMobile) return;
				if (!val) return;
				this.state.computeSingleColPositions();
			}
		}
	},
	methods: {
		preventOverlap(){
			this.state.preventOverlap();
		},
		onMouseMove(event:MouseEvent){
			this.state.onMouseMove(event, this.$el as HTMLElement);
		},
		onResize(){
			this.state.storeRects();
		}
	},
	mounted(){
		this.observer = new ResizeObserver(this.onResize);
		this.observer.observe(this.$el);
	},
	destroyed(){
		if (!this.observer) return;
		this.observer.disconnect();
	}
});
